var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripadvisor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_11954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0.14209C11.2893 0.14209 0.14209 11.2893 0.14209 25C0.14209 38.7108 11.2893 49.858 25 49.858C38.7108 49.858 49.858 38.7108 49.858 25C49.858 11.2893 38.7108 0.14209 25 0.14209Z",
    fill: "#00AF87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4545 26.5152C15.4545 25.6199 16.1776 25.0001 17.0454 25.0001C17.9131 25.0001 18.6363 25.6199 18.6363 26.5152C18.6363 27.4106 17.9854 28.0304 17.0454 28.0304C16.1053 28.0304 15.4545 27.3417 15.4545 26.5152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0454 21.9698C14.4421 21.9698 12.2726 23.8293 12.2726 26.5152C12.2726 28.9946 14.2251 31.0607 17.0454 31.0607C19.8656 31.0607 21.8181 29.2012 21.8181 26.5152C21.8181 23.8293 19.6487 21.9698 17.0454 21.9698ZM17.0454 23.4849C15.3098 23.4849 13.8635 24.7246 13.8635 26.5152C13.8635 28.1681 15.1652 29.5455 17.0454 29.5455C18.9255 29.5455 20.2272 28.3059 20.2272 26.5152C20.2272 24.7246 18.7809 23.4849 17.0454 23.4849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5454 26.5152C34.5454 25.6199 33.8222 25.0001 32.9545 25.0001C32.0867 25.0001 31.3635 25.6199 31.3635 26.5152C31.3635 27.4106 32.0144 28.0304 32.9545 28.0304C33.8945 28.0304 34.5454 27.3417 34.5454 26.5152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9545 21.9698C35.5578 21.9698 37.7272 23.8293 37.7272 26.5152C37.7272 28.9946 35.7747 31.0607 32.9545 31.0607C30.1342 31.0607 28.1817 29.2012 28.1817 26.5152C28.1817 23.8293 30.3512 21.9698 32.9545 21.9698ZM32.9545 23.4849C34.69 23.4849 36.1363 24.7246 36.1363 26.5152C36.1363 28.1681 34.8346 29.5455 32.9545 29.5455C31.0743 29.5455 29.7726 28.3059 29.7726 26.5152C29.7726 24.7246 31.2189 23.4849 32.9545 23.4849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8635 18.9149C16.8085 17.1405 20.913 15.9092 24.9999 15.9092C29.0868 15.9092 33.1913 17.1405 36.1363 18.9149L40.909 18.9395L39.2138 21.9486C40.1755 23.1506 40.909 24.8553 40.909 26.5152C40.909 30.6937 37.1704 34.091 32.9032 34.091C30.379 34.091 28.0933 32.7206 26.5908 31.0607L24.9999 34.091L23.409 31.0607C21.9065 32.7206 19.6208 34.091 17.0966 34.091C12.8294 34.091 9.09082 30.6937 9.09082 26.5152C9.09082 24.8553 9.82437 23.1506 10.786 21.9486L9.09082 18.9395L13.8635 18.9149ZM24.9999 25.7577C25.3004 21.9226 28.8164 18.9967 32.9032 18.9395C30.6795 18.0237 27.8247 17.4243 24.9999 17.4243C22.1752 17.4243 19.3203 18.0237 17.0966 18.9395C21.1835 18.9967 24.6994 21.9226 24.9999 25.7577ZM17.0966 32.6028C13.6107 32.6028 10.6817 29.8351 10.6817 26.5152C10.6817 23.1954 13.6107 20.4032 17.0966 20.4032C20.5825 20.4032 23.4072 23.1954 23.4072 26.5152C23.4072 29.7779 20.5825 32.6028 17.0966 32.6028ZM32.9032 32.6028C36.3891 32.6028 39.3181 29.8351 39.3181 26.5152C39.3181 23.1954 36.3891 20.4032 32.9032 20.4032C29.4174 20.4032 26.5926 23.1954 26.5926 26.5152C26.5926 29.7779 29.4174 32.6028 32.9032 32.6028Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_11954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripadvisor);
export default __webpack_public_path__ + "static/media/Tripadvisor.523b5399a945e0d95567bd17be7bf1ff.svg";
export { ForwardRef as ReactComponent };